<script lang="ts">
  import { onMount } from "svelte";
import Button from "../../components/Button.svelte";
import SrlDropdown from "../../components/Form/Fields/Dropdown/SrlDropdown.svelte";
import Switch from "../../components/Form/Fields/Switch.svelte";
import FormField from "../../components/Form/FormField.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { leadDtoFields } from "../../utils/TableFields/lead-dto.fields";

  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    clearSearch,
    tableCustomFields,
  } from "./lead.store";

  $: tableFields = [...leadDtoFields, ...$tableCustomFields];

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="lead"
    entityPlural="leads"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
  <div slot="search" class="level">
     
    <div class="level-item">
      <div style="width: 8rem;"> 
        <FormField>
          <SrlDropdown
            name="Stato Lead"
            schema="LEADSTATUS" 
            required={false}
            clearVisible={false}
            on:select={search}
            bind:value={$filter.criteria.srlLeadStatusId}
          />
        </FormField>        
      </div>      
    </div>
    <div class="level-item">
      <div> 
        <FormField usageHelp="Mostra solo lead persi">
          <Switch
            name=""
            condensed={true}
            altText="Mostra solo lead persi"
            bind:value={$filter.criteria.failure}
            on:toggle={search}
          />
        </FormField> 

        <FormField usageHelp="Mostra solo lead vinti">
          <Switch
            name=""
            condensed={true}
            altText="Mostra solo lead vinti"
            bind:value={$filter.criteria.success}
            on:toggle={search}
          />
        </FormField> 
      </div>
    </div>
    <div class="level-item">
      <div> 
        <FormField usageHelp="Mostra solo lead chiusi">
          <Switch
            name=""
            condensed={true}
            altText="Mostra solo lead chiusi"
            bind:value={$filter.criteria.closed}
            on:toggle={search}
          />
        </FormField>  

        <FormField usageHelp="Mostra solo lead aperti">
          <Switch
            name=""
            condensed={true}
            altText="Mostra solo lead aperti"
            bind:value={$filter.criteria.open}
            on:toggle={search}
          />
        </FormField> 
      </div>
    </div>
 
<!--
    <div class="level-item">
      <p class="control">
        <Button on:click={search}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    
    -->
    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div> 
  </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
